import { AbstractControl, ValidationErrors } from "@angular/forms";

export function optionalEmailValidator(control: AbstractControl): ValidationErrors | null {
  let emailValue: string = control.value;
  if (emailValue === null || emailValue === '')
    return null;

  if (emailValue !== emailValue.trim()) {
    return { 'whitespace': 'Email cannot have leading or trailing whitespace' };
  }

  if (emailValue.trim() === '') {
    return { 'empty-string': 'Value cannot be empty' };
  }

  if (emailValue && emailValue.indexOf('@') === -1) {
    return null;
  }

  return null;
  //return Validators.email(control);
}
